import React, {useEffect} from 'react';
import {Navigate, Outlet, useLocation, useNavigate, useParams} from 'react-router-dom';
import {useSelector} from 'react-redux';
import {useRoomSocket} from '../../../hooks/useRoomSocket';
import {usePresentationParams} from '../../../hooks/usePresentationParams';
import {useCaptureRedirectUri} from '../../../hooks/useCaptureRedirectUri';
import RoomLoaderWrapper from './RoomLoaderWrapper';
import RoomEndCountdown from './parts/RoomEndCountdown';
import {roomSelector} from '../../../store/selectors/roomRunFile.selectors';
import {RoomStatus} from '../../../incase-domain/rooms/room.player';

function RoomWrapper(): JSX.Element {
    useRoomSocket();
    useCaptureRedirectUri();

    const navigate = useNavigate();
    const location = useLocation();
    const {roomId} = usePresentationParams();
    const {slug} = useParams<{slug?: string}>();
    const basePath = slug ? `/room/${slug}` : '/room';

    const room = useSelector(roomSelector);

    useEffect(() => {
        if (roomId === room.roomId) {
            const targetPath = room.roomStatus === RoomStatus.PLAYING ? `${basePath}/play` : `${basePath}/lobby`;

            if (location.pathname !== targetPath) {
                navigate({pathname: targetPath, search: location.search}, {replace: true});
            }
        }
    }, [roomId, room.roomStatus, room.roomId, basePath, location.pathname, location.search, navigate]);

    if (!roomId) {
        return <Navigate replace to="/" />;
    }

    return (
        <RoomLoaderWrapper>
            <RoomEndCountdown />
            <Outlet />
        </RoomLoaderWrapper>
    );
}

export default RoomWrapper;
